import { Typography as MuiTypography } from "@material-ui/core";
import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";
import { z } from "zod";
import useQueryParams from "../../hooks/useQueryParams";
import FiltersForm from "../../components/FiltersForm";
import YearBarChartContainer from "../../components/charts/yearBarChart/YearBarChartContainer";
import React, { useMemo } from "react";
import useDropdown from "../../hooks/useDropdown";
import { usePostHeight } from "../../hooks/usePostHeight";

const Section = styled.section`
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fff;
`;

const Typography = styled(MuiTypography)(spacing);

const DEFAULT_SEARCH_PARAMS = { locationid: 79, parameterid: 29 };
const searchParamsSchema = z.object({
  locationid: z.coerce.number().default(DEFAULT_SEARCH_PARAMS.locationid),
  parameterid: z.coerce.number().default(DEFAULT_SEARCH_PARAMS.parameterid),
  controls: z.preprocess(
    (val) => val === "true" || val === true,
    z.boolean().default(false)
  ),
  height: z.preprocess(
    (val) => (typeof val === "string" ? parseInt(val, 10) : val),
    z.number().default(400)
  ),
});

export default function YearComparisonEmbed() {
  usePostHeight();
  const { params, setParams } = useQueryParams(searchParamsSchema);

  const locOptions = useDropdown(
    "results-simple/download-dropdown-locs-active"
  );
  const parOptions = useDropdown(
    "results-simple/list-parameters-dropdown-simple-active"
  );

  const getLocationLabel = () => {
    const location = locOptions.find(
      (l) => l.value === String(params.locationid)
    );
    return location ? location.label : "Location";
  };

  const getParameterLabel = () => {
    const parameter = parOptions.find(
      (p) => p.value === String(params.parameterid)
    );
    return parameter ? parameter.label : "Parameter";
  };

  const FILTERS_CONFIG = useMemo(
    () => [
      {
        type: "auto",
        param: "locationid",
        label: "Surface-water location",
        default: String(params.locationid),
        options: locOptions,
      },
      {
        type: "auto",
        param: "parameterid",
        label: "Parameter",
        default: String(params.parameterid),
        options: parOptions,
      },
    ],
    [locOptions, parOptions, params]
  );

  return (
    <>
      <main>
        {params.controls && (
          <Section>
            <Typography variant="h5" component="h2" gutterBottom>
              Filters
            </Typography>
            <FiltersForm config={FILTERS_CONFIG} onChange={setParams} />
          </Section>
        )}

        <Section>
          <Typography variant="h5" component="h2" gutterBottom>
            {getParameterLabel()} at {getLocationLabel()}
          </Typography>
          <YearBarChartContainer
            locationid={params.locationid}
            parameterid={params.parameterid}
            height={params.height}
          />
        </Section>
      </main>
    </>
  );
}
